export default {
  blue: '#0000FF',
  lightGrey: '#ABABAB',
  offBlack: '#111111',
  offWhite: '#D8D8D8',
};
